import React from 'react';

import { makeStyles } from 'tss-react/mui';

import type { MarkdownComponentProps } from '../ChatPanelMarkdown';

const useHeadingStyles = makeStyles()(theme => ({
  h1: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: 1.235,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  h2: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: 1.334,
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(2.5),
  },
  h3: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1.6,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  h4: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1.5),
  },
  h5: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(1.5),
  },
  h6: {
    fontSize: 12,
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(1),
  },
}));

export const H1Element = ({ children, ...props }: MarkdownComponentProps<HTMLHeadingElement>) => {
  const { classes } = useHeadingStyles();
  return (
    <h1 className={classes.h1} {...props}>
      {children}
    </h1>
  );
};

export const H2Element = ({ children, ...props }: MarkdownComponentProps<HTMLHeadingElement>) => {
  const { classes } = useHeadingStyles();
  return (
    <h2 className={classes.h2} {...props}>
      {children}
    </h2>
  );
};

export const H3Element = ({ children, ...props }: MarkdownComponentProps<HTMLHeadingElement>) => {
  const { classes } = useHeadingStyles();
  return (
    <h3 className={classes.h3} {...props}>
      {children}
    </h3>
  );
};

export const H4Element = ({ children, ...props }: MarkdownComponentProps<HTMLHeadingElement>) => {
  const { classes } = useHeadingStyles();
  return (
    <h4 className={classes.h4} {...props}>
      {children}
    </h4>
  );
};

export const H5Element = ({ children, ...props }: MarkdownComponentProps<HTMLHeadingElement>) => {
  const { classes } = useHeadingStyles();
  return (
    <h5 className={classes.h5} {...props}>
      {children}
    </h5>
  );
};

export const H6Element = ({ children, ...props }: MarkdownComponentProps<HTMLHeadingElement>) => {
  const { classes } = useHeadingStyles();
  return (
    <h6 className={classes.h6} {...props}>
      {children}
    </h6>
  );
};
